import { connect } from "react-redux"
import { update_profile, load_user } from "../../redux/actions/auth/auth"
import { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'

  function EditProfile({
    user,
    update_profile,
    load_user,

  }) {
    const [userAux, setUserAux] = useState(null)
    const [open, setOpen] = useState(false)
    const [profile_picture_aux, setProfilePictureAux] = useState(null)

    const handleCancel = function(){
      setUserAux(null)
      setOpen(false)
      setProfilePictureAux(null)
    }

    const handleChanges = function(e){
      const { name, value } = e.target;
      setUserAux((prevUserAux) => ({
        ...prevUserAux,
        [name]: value,
      }));
    }

    
    const handleFotoChange = (e) => {
      const selectedFile = e.target.files[0];
      if (selectedFile) {

        const imageURL = URL.createObjectURL(selectedFile);
        setProfilePictureAux(imageURL)

        setUserAux((prevUserAux) => ({
          ...prevUserAux,
          profile_picture: selectedFile,
        }));
      }
    };
   
    const handleAPI = async function(){
      if (userAux){
        const formData = new FormData();
        Object.entries(userAux).forEach(([key, value]) => {
          formData.append(key, value);
        });

        await update_profile(formData)
        handleCancel()
        await load_user()
      }
    }


    return (
      <>
       
        <div className="flex-1 bg-white px-10 md:px-32 pt-5 md:pt-20 grid md:grid-cols-4">
          <div className="col-span-3 max-w-[90%]">
              <h1 className="font-bold text-4xl mb-10">Perfil</h1>
              <div className="flex flex-col justify-center">
                <label className="text-gray-800 text-xl font-bold mb-2">Nombre</label>
                <p className="text-gray-800 text-xl pb-5 border-b">{user&&user.first_name}</p>

                <label className="text-gray-800 mt-2 text-xl font-bold mb-2">Primer Apellido</label>
                <p className="text-gray-800 text-xl pb-5 border-b">{user&&user.last_name}</p>

                <label className="text-gray-800 mt-2 text-xl font-bold mb-2">Segundo Apellido</label>
                <p className="text-gray-800 text-xl pb-5 border-b">{user&&user.second_last_name}</p>

                <label className="text-gray-800 mt-2 text-xl font-bold mb-2">Correo Electrónico</label>
                <p className="text-gray-800 text-xl pb-5 border-b">{user&&user.email}</p>
              </div>
          </div>
          <div className="flex flex-col items-center justify-start">
            <img src={`${process.env.REACT_APP_MEDIA}${user&&user.profile_picture}`} className="ring-2 ring-black h-44 w-44 object-cover rounded-full" />
            <button onClick={() => setOpen(true)} className="font-semibold text-xl mt-10 border-white border-3 border-b hover:border-black">
                  Editar Perfil
            </button>
          </div>
          
        </div>
     
       <Dialog open={open} onClose={handleCancel} className="relative z-10">
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform overflow-hidden rounded-3xl bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                      <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                        Tus Datos 
                      </DialogTitle>
                      <div className="mt-2 grid grid-cols-2 gap-x-5">
                        <div className="col-span-1">
                          <label htmlFor="first-name" className="block text-sm/6 font-medium text-gray-900">
                            Nombre
                          </label>
                          <div className="mt-2">
                            <input
                              id="first-name"
                              name="first_name"
                              type="text"
                              placeholder={user&&user.first_name}
                              onChange={(e) => handleChanges(e)}
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            />
                          </div>
                          <label htmlFor="first-name" className="block text-sm/6 font-medium text-gray-900 mt-4">
                            Primer apellido
                          </label>
                          <div className="mt-2">
                            <input
                              id="last-name"
                              name="last_name"
                              type="text"
                              placeholder={user&&user.last_name}
                              onChange={(e) => handleChanges(e)}
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            />
                          </div>
                          <label htmlFor="first-name" className="block text-sm/6 font-medium text-gray-900 mt-4">
                            Segundo apellido
                          </label>
                          <div className="mt-2">
                            <input
                              id="second-last-name"
                              name="second_last_name"
                              type="text"
                              placeholder={user&&user.second_last_name}
                              onChange={(e) => handleChanges(e)}
                              className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6"
                            />
                          </div>
                        </div>
                        <div className="col-span-1 flex flex-col items-center gap-y-3">
                          <label className="block text-sm/6 font-medium text-gray-900">
                            Foto Perfil
                          </label>
                          <img 
                            src={
                              profile_picture_aux
                                ? profile_picture_aux
                                : `${process.env.REACT_APP_MEDIA}${user?.profile_picture}`
                            } 
                            className="size-24 object-cover rounded-full" 
                          />
                          <label htmlFor="file-upload" className="button bg-gray-200 p-2 mt-2 rounded-3xl cursor-pointer text-sm/6 ">
                            Cambiar Imagen
                          </label>
                          <input
                            type="file"
                            id="file-upload"
                            name="profile_picture"
                            onChange={(e) => handleFotoChange(e)}
                            accept="image/*"
                            className="hidden" 
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    onClick={handleAPI}
                    className="inline-flex w-full justify-center rounded-3xl bg-blue-green px-3 py-2 text-sm font-semibold text-white shadow-sm hover:opacity-90 sm:ml-3 sm:w-auto"
                  >
                    Confirmar
                  </button>
                  <button
                    type="button"
                    data-autofocus
                    onClick={handleCancel}
                    className="mt-3 inline-flex w-full justify-center rounded-3xl bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  >
                    Cancelar
                  </button>
                </div>
              </DialogPanel>
            </div>
          </div>
      </Dialog>

      </>
    )
  }

  const mapStateToProps=state=>({
    user: state.auth.user,
  })

  export default connect(mapStateToProps,{
    update_profile,
    load_user,
  })(EditProfile)